/* eslint-disable prettier/prettier */
export default {
  path: '/ReqCard',
  name: 'ReqCard',
  component: () => import('../views/layouts/ReqCard.layout.vue'),
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: 'add/:guid',
      name: 'ReqCardAddEdit',
      component: () => import('../views/pages/ReqCard/ReqCardAddEdit.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'oldEmp/add',
      name: 'ReqCardAddOldEmp',
      component: () =>
        import('../views/pages/ReqCard/ReqCardAddOldEmp.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'oldEmp/edit',
      name: 'ReqCardEditOldEmp',
      component: () =>
        import('../views/pages/ReqCard/ReqCardEditOldEmp.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'info/:guid',
      name: 'ReqCardInfo',
      component: () => import('../views/pages/ReqCard/ReqCardInfo.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'list/:guid',
      name: 'ReqCardList',
      component: () => import('../views/pages/ReqCard/ReqCardList.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'req/:cardcode/:type',
      name: 'ReqCardRequestInfo',
      component: () =>
        import('../views/pages/ReqCard/ReqCardRequestInfo.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/',
      name: 'ReqCardInfo',
      component: () => import('../views/pages/ReqCard/ReqCardInfo.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'admin',
      name: 'ReqCardAdmin',
      component: () => import('../views/pages/ReqCard/ReqCardAdmin.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'rptdetail',
      name: 'ReqCardReportDetail',
      component: () =>
        import('../views/pages/ReqCard/ReqCardReportDetail.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'rptsummary',
      name: 'ReqCardReportSummary',
      component: () =>
        import('../views/pages/ReqCard/ReqCardReportSummary.page.vue'),
      meta: {
        requiresAuth: true,
      },
    },
  ],
}
